import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';
import * as _ from 'lodash';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McMfPatientService {

  constructor(
    private sdk: MycureSDK
  ) {

  }

  /**
   * Create/Update patient
   * @param data 
   */
  async modifyPatient(data: any) {
    let _patientId = data.id;
    let _res: any;

    // construct patient data
    let _patient: any = _.pick(data, ['facility']);
    _patient.personalDetails = {
      ..._.pick(data, [
        'name', 'sex', 'dateOfBirth', 'address', 'bloodType',
        'mobileNo', 'homeNo', 'workNo', 'emergencyNo',
        'emergencyContactName', 'emergencyContactRelationship',
        'emergencyContactMobileNo', 'company', 'companyPosition',
        'companyAddress', 'fathersName', 'fathersMobileNo',
        'fathersReligion', 'fathersNationality', 'mothersName',
        'mothersMobileNo', 'mothersReligion',
      ])
    };

    // if px has no id, create it.
    if (!_patientId) {
      _res = await this.sdk.mf.patients().create(_patient);
    } else {
      // update personal details only
      _res = await this.sdk.personalDetails().update(_patientId, _patient.personalDetails);
    }

    // update insurance
    await this.updatePatientInsurance(_res.id, data);

    // update tags
    await this.updatePatientTag(_res.id, data);

    // update pics
    await this.updatePatientPic(_res.id, data);

    // return created px
    return _res;
  }

  /**
   * Update Patient Insurance Cards
   * @param data 
   */
  private async updatePatientInsurance(patientId: string, data: any) {
    let _oldInsurance: any[] = data._insurance || [];
    let _insurance: any[] = data.insuranceCards || [];

    // if px has insurance cards
    if (_insurance && patientId) {
      // get all codes only
      const _insuranceIds = _oldInsurance.map((item: any) => {
        return item.id;
      });

      const update1 = { $pull: { insuranceCards: { id: { $in: _insuranceIds } } } };
      await this.sdk.personalDetails().update(patientId, update1);
      const update2 = { $addToSet: { insuranceCards: { $each: _insurance } } };
      await this.sdk.personalDetails().update(patientId, update2);
    }
  }

  /**
   * Update Patient Tags
   * @param data 
   */
  private async updatePatientTag(patientId: string, data: any) {
    let _tags: string[] = data.tags || [];

    // if px has tags, update it.
    if (_tags && patientId) {
      const update1 = { $pull: { tags: { $in: _tags } } };
      await this.sdk.personalDetails().update(patientId, update1);
      const update2 = { $addToSet: { tags: { $each: _tags } } };
      await this.sdk.personalDetails().update(patientId, update2);
    }
  }

  /**
   * Update Patient Pic
   * @param data 
   */
  private async updatePatientPic(patientId: string, data: any) {
    let _pics: any = data.pendingPicUpload;

    if (patientId && _pics && _pics.filePath) {
      const file = _pics.filePath;
      const item = await this.sdk.mf.patients().uploadPic(patientId, file, { path: `/mf-patients/${patientId}` });
      const picURL = await item.upload();
      // upload profile pic
      await this.sdk.personalDetails().update(patientId, { picURL });
    }
  }
}
